import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

export async function getAssessmentQueue() {
  const res = await api.get('/assessments');
  return res.data;
}

export async function getAssessmentByRow(mcRow, aiaSheetRow) {
  const params = aiaSheetRow ? `?aiaRow=${aiaSheetRow}` : '';
  const res = await api.get(`/assessments/${mcRow}${params}`);
  return res.data;
}

export async function submitDecision(mcRow, action, payload) {
  const res = await api.post(`/assessments/${mcRow}/decision`, { action, ...payload });
  return res.data;
}

export async function triggerCtos(ssmNumber, outletName, rowNumber) {
  const res = await api.post('/ctos-report', { ssm_number: ssmNumber, outlet_name: outletName, row_number: rowNumber });
  return res.data;
}